import { render, staticRenderFns } from "./VisitCard.vue?vue&type=template&id=11c5ee8a&scoped=true&"
import script from "./VisitCard.vue?vue&type=script&lang=js&"
export * from "./VisitCard.vue?vue&type=script&lang=js&"
import style0 from "./VisitCard.vue?vue&type=style&index=0&id=11c5ee8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c5ee8a",
  null
  
)

component.options.__file = "VisitCard.vue"
export default component.exports